var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-16"},[_c('a',{staticClass:"fixed top-0",attrs:{"id":"main-content","tabindex":"-1"}}),_vm._v(" "),_c('Map2D',{attrs:{"layers":_vm.mapLayers,"is-first-menu-item-hidden":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }